import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { updateChildAccount, fetchChildAccounts } from '../../../api'; // Adjust the path as necessary
import MyButton from '../../basic/MyButton'; // Adjust path if necessary
import MyTextInput from '../../basic/MyTextInput'; // Adjust path if necessary

Modal.setAppElement('#root'); // Ensure this is set for accessibility

function ModalEditAccount({ isOpen, onClose, childId, accountId, onEditSuccess }) {
    const [accountName, setAccountName] = useState('');
    const [goalAmount, setGoalAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            fetchChildAccounts(childId)
                .then(accounts => {
                    const account = accounts.find(acc => acc.account_id === accountId);
                    if (account) {
                        setAccountName(account.account_name);
                        setGoalAmount(account.goal_amount || '');
                        setError('');
                    } else {
                        setError('Account not found.');
                    }
                })
                .catch(err => {
                    console.error('Error fetching account details:', err);
                    setError('Failed to load account details.');
                })
                .finally(() => setLoading(false));
        }
    }, [isOpen, childId, accountId]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'accountName') {
            setAccountName(value);
        } else if (name === 'goalAmount') {
            setGoalAmount(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!accountName.trim()) {
            setError('Account name is required.');
            return;
        }

        if (accountName.trim().toLowerCase() === 'checking' || accountName.trim().toLowerCase() === 'savings') {
            setError('Account name cannot be "Checking" or "Savings".');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const updatedAccount = await updateChildAccount(childId, accountId, {
                account_name: accountName.trim(),
                goal_amount: goalAmount ? parseFloat(goalAmount) : null
            });
            onEditSuccess(`Account "${updatedAccount.account_name}" has been updated successfully.`);
            onClose();
        } catch (err) {
            console.error('Error updating account:', err);
            setError('Failed to update account. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)'
                }
            }}
        >
            <h2>Edit Account</h2>
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
                <MyTextInput
                    label="Account Name"
                    name="accountName"
                    value={accountName}
                    onChange={handleInputChange}
                    required
                />
                <MyTextInput
                    label="Saving Goal Amount - Optional"
                    name="goalAmount"
                    value={goalAmount}
                    onChange={handleInputChange}
                    type="number"
                    min="0"
                    step="0.01"
                />
                <MyButton 
                    text={loading ? 'Updating...' : 'Update Account'} 
                    onClick={handleSubmit} 
                    disabled={loading}
                />
                <MyButton 
                    text="Cancel" 
                    onClick={onClose} 
                    backgroundColor="white"
                    color="#dc3545"
                    hoverBackgroundColor="#f8f8f8"
                    hoverColor="#c82333"
                />
            </form>
        </Modal>
    );
}

export default ModalEditAccount;